<template>
<md-sidenav class="md-left" ref="revisionNav">
    <md-toolbar class="md-dense main-toolbar">
        <md-button class="md-icon-button" @click="back()">
            <md-icon>menu</md-icon>
        </md-button>
        <h3 class="md-title">Revisions</h3>
    </md-toolbar>
    <h2>{{version.version}}</h2>
    <revisions-list :mutations="mutations"/>
</md-sidenav>
</template>

<script>
import NavBus from '@/buses/nav';
import RevisionList from '@/components/history/revisions-list';

const RevisionsNav = {
    name: 'RevisionsNav',
    props: ['version', 'project'],
    data: function() {
        return {
        };
    },
    computed: {
        mutations() {
            const results = [];
            if (this.$props.version.mutations) {
                this.$props.version.mutations.forEach((mutation, m) => {
                    const obj = {};
                    obj.id = m;
                    obj.project = this.$props.project;
                    obj.version = this.$props.version;
                    obj.mutation = mutation;
                    results.push(obj);
                });
            }

            return results;
        }
    },
    methods: {
        open() {
            if (this.$refs.revisionNav) {
                this.$refs.revisionNav.open();
            }
        },
        close() {
            this.$refs.revisionNav.close();
        },
        closeRevisionsNav() {
            this.$refs.revisionNav.close();
        },
        back() {
            this.$emit('back');
        }
    },
    created: function() {
        NavBus.$on('revisions-nav.open', () => {
            if (this.$refs.revisionNav) {
                this.$refs.revisionNav.open();
            }
        });
    },
    components: {
        'revisions-list': RevisionList
    }
};
export default RevisionsNav;

</script>

<style></style>


// WEBPACK FOOTER //
// revisions-nav.vue?73e29952